const dailyApi = require('../api/dailyQuests');
const { updateBalance } = require('./helpers');

const MIN_QUESTS_UPDATE = 1000 * 60 * 5; // 5 minutes
const FETCH_QUESTS_TIMEOUT = 1000 * 30; // 30 seconds

function fetchIntervalProgressInProgress() {
  return {
    type: 'FETCH_INTERVAL_PROGRESS_IN_PROGRESS',
    timestamp: Date.now(),
  };
}

function fetchIntervalProgressSuccessful(progress) {
  return {
    type: 'FETCH_INTERVAL_PROGRESS_SUCCESSFUL',
    progress,
    timestamp: Date.now(),
  };
}

function fetchIntervalProgressFailed(reason) {
  return {
    type: 'FETCH_INTERVAL_PROGRESS_FAILED',
    reason,
    timestamp: Date.now(),
  };
}

function fetchIntervalProgress() {
  return (dispatch, getState) => {
    dispatch(fetchIntervalProgressInProgress());

    const state = getState();
    const { apiUrl } = state.auth;
    const { token } = state.auth;

    if (!apiUrl || !token) {
      return Promise.resolve();
    }

    return dailyApi.fetchIntervalProgress(apiUrl, token).then(
      (progress) => {
        dispatch(fetchIntervalProgressSuccessful(progress));
        return {
          progress,
        };
      },
      (error) => {
        dispatch(fetchIntervalProgressFailed(error));
        throw error;
      },
    );
  };
}

function shouldFetchIntervalProgress(state, skipOutdatedCheck) {
  const { fetchingInProgressSince, didInvalidate, lastSuccessfulFetch } =
    state.intervalProgress;

  if (!fetchingInProgressSince) {
    // Should update if it was explicetely invalidated
    if (didInvalidate) {
      return true;
    }

    if (
      new Date(lastSuccessfulFetch).getUTCDate() !== new Date().getUTCDate()
    ) {
      return true;
    }

    // Should update if data is too old
    if (
      !skipOutdatedCheck &&
      (!lastSuccessfulFetch ||
        Date.now() - lastSuccessfulFetch > MIN_QUESTS_UPDATE)
    ) {
      return true;
    }
  } else if (
    fetchingInProgressSince &&
    Date.now() - fetchingInProgressSince > FETCH_QUESTS_TIMEOUT
  ) {
    // Ensure we cannot get stuck in fetchingInProgressSince=true state.
    return true;
  }

  return false;
}

function fetchIntervalProgressIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchIntervalProgress(getState())) {
      return dispatch(fetchIntervalProgress());
    }
    return Promise.resolve();
  };
}

function handleSuccessfulClaim(result, dispatch) {
  updateBalance(dispatch, result);

  switch (result.type) {
    case 'lootcoins':
    case 'diamonds':
    case 'loottickets':
      return;
    case 'lootpack':
      dispatch({
        type: 'ADD_PURCHASE',
        purchase: result.purchases,
        timestamp: Date.now(),
      });
      return;
    case 'lootcard':
      dispatch({
        type: 'ADD_CARDS',
        cards: result.cards,
        timestamp: Date.now(),
      });
      return;
    default:
      dispatch({
        type: 'UNKNOWN_CODE_TYPE',
        timestamp: Date.now(),
      });
  }
}

function claimInterval(captchaToken) {
  return (dispatch, getState) => {
    const state = getState();
    const { apiUrl, token } = state.auth;

    if (!apiUrl || !token) {
      return Promise.resolve();
    }

    return dailyApi.claimIntervalReward(apiUrl, token, captchaToken).then(
      (result) => {
        handleSuccessfulClaim(result, dispatch);
        dispatch(fetchIntervalProgressSuccessful(result.progress));
      },
      (error) => {
        throw error;
      },
    );
  };
}

module.exports = {
  fetchIntervalProgress,
  fetchIntervalProgressIfNeeded,
  claimInterval,
};
